import {
  withTranslation,
} from 'react-i18next';

import RegattaRequirementFieldsView from './RegattaRequirementFieldsView';

const TranslatedComponent = withTranslation()(RegattaRequirementFieldsView);

const Component = TranslatedComponent;

export default Component;
